import { render, staticRenderFns } from "./MobileMenuLanguage.vue?vue&type=template&id=4aa22684&scoped=true&"
import script from "./MobileMenuLanguage.vue?vue&type=script&lang=js&"
export * from "./MobileMenuLanguage.vue?vue&type=script&lang=js&"
import style0 from "./MobileMenuLanguage.vue?vue&type=style&index=0&id=4aa22684&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa22684",
  null
  
)

export default component.exports